<template>
  <div class="leftres">
    <div>
      <div :class=" showorhide ? 'inputtop' : 'inputtops' ">
        <div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
          <Commondropdownlist :options="item.options" ref="msgFormSon" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" @cascaderchange="cascaderchange"></Commondropdownlist>
        </div>
        <div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
          <CommonBtngroup ref="btngroup" :chackbox="chackbox" checktitle="是否经销商前台菜单" marginRight="510px" :show="showorhide" @showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
        </div>
        <div style="height:10px;">
        </div>
      </div>
      <div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px;background-color: #FFFFFF;">
        <Menumanagementtable :tableData="tableData" :total="total" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></Menumanagementtable>
      </div>
      <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK" :src="'../assets/icon/icon-errors.png'">
        <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
      </Dialog>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../components/commongroup.vue'
import Dialog from '../../components/dialog.vue'
import Menumanagementtable from './components/menumanagementtable.vue'
import { SearchList, MenuList } from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    Dialog,
    Menumanagementtable
  },

  data() {
    return {
      username: '',
      name: '',
      dialogVisibles: false,
      showorhide: true,
      chackbox: true,
      tableData: [],
      total: 0,
      pageindex: 1,
      pageSize: 20,
      menuname: '',
      enabled: null,
      p_MenuID: '',
      IsCusWeb: '',
      formdata: [
        {
          inputdata: '',
          title: '父级菜单',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请选择',
          types: '',
          inputtype: 'cascaderNode',
          width: '300px',
          options: [],
        },
        {
          inputdata: '',
          title: '菜单名称',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '290px',
          lablewith: '155px'
        },
        {
          inputdata: '',
          title: '是否可用',
          fontSize: '14px',
          color: '#333333',
          placeholder: '全部',
          types: '',
          inputtype: 'select',
          width: '300px',
          options: [
            {
              value: '全部',
              key: null
            }, {
              value: '是',
              key: '1'
            }, {
              value: '否',
              key: '0'
            },
          ],
           lablewith: '155px'
        },
      ]
    }
  },
  created() {
  },
  mounted() {
    this.searchList()
    this.menuList()
    this.loading()
  },
  methods: {
    // 搜索下拉框
    async searchList() {
      let {
        code,
        data
      } = await SearchList({

      })
      if (code == 0) {
        this.formdata[0].options = data
      }
    },
    // 查询
    async menuList() {
      let resmenu = await MenuList({
        pageSize: this.pageSize,
        pageIndex: this.pageindex,
        menuName: this.menuname,
        p_MenuID: this.p_MenuID,
        IsCusWeb: this.IsCusWeb,
        enabled: Number(this.enabled) == 0 ? null : Number(this.enabled),
      })

      if (resmenu.code == 0) {
        if (resmenu.data) {
          this.total = resmenu.data.count
          this.tableData = resmenu.data.data
        }
      }
    },
    loading() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
      }, 500);
    },
    reset() {
      this.$refs.msgFormSon.map((item, index) => {
        item.modelvalue = ''
      })
      // this.dialogVisibles = true
    },
    cancel() {
      //console.log('name')
      this.dialogVisibles = false
    },
    select() {
      //console.log(this.$refs.btngroup,"btngroup");
      this.pageindex = 1
      try {
        let e = this.$refs.msgFormSon
        this.menuname = e[1].modelvalue
        this.p_MenuID = e[0].modelvalue
        this.enabled = e[2].modelvalue
        this.IsCusWeb = this.$refs.btngroup.checkeds == true ? 1 : 0
        this.menuList()
      } catch (error) {
        this.menuList()
      }
    },
    dialogOK() {
      //console.log('name2')
      this.dialogVisibles = false
    },
    hide() {
      this.showorhide = false
      //console.log("askdas", this.showorhide)

    },
    showclick() {
      this.showorhide = true
    },
    handleCurrentChange(pageindex) {
      this.pageindex = pageindex
      this.menuList()
    },
    handleSizeChange(paegSzie) {
      this.pageSize = paegSzie
      this.menuList()
    },
    cascaderchange(e) {
      //console.log(e, "ee")
    }
  },
  watch: {
    showorhide: {
      handler(newVal, oldVal) {
        if (newVal == false) {
          this.chackbox = false
        } else {
          this.chackbox = true
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 60px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  transition: all .3s;
  overflow: hidden;
}
.inputtops {
  width: 980px;
  height: 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 9px;
  padding-bottom: 64px;
  overflow: hidden;
  position: relative;
  transition: all .3s;
}

.Btngroup {
  display: inline-block;
  float: right;
  margin-right: 20px;
  width: 400px;
  height: 60px;
  background-color: #ffffff;
  position: relative;
  bottom: 55px;
}
.Btngroups {
  display: inline-block;
  float: right;
  margin-top: 5px;
  margin-right: 30px;
}

</style>